module.exports = __webpack_public_path__ + "img/app-3-on.ef1eb18f.png";